exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Avatar-imgBackground-tu1HZ {\n\tbackground-color: #fff;\n\tborder: 3px solid #fff;\n\tborder-radius: 50%;\n\tmargin-left: 2px;\n}", ""]);

// exports
exports.locals = {
	"imgBackground": "Avatar-imgBackground-tu1HZ"
};